import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type ScreenLevelSelectionState = Record<
  string,
  {
    brands?: number[];
    markets?: number[];
    segments?: number[];
    secondaryBrands?: number[];
  }
>;

const initialState: ScreenLevelSelectionState = {};

export const screenLevelSelectionSlice = createSlice({
  name: "screenLevelSelection",
  initialState,
  reducers: {
    updateScreenLevelSelection: (
      state: ScreenLevelSelectionState,
      action: PayloadAction<{
        screenType: keyof ScreenLevelSelectionState;
        value: Partial<
          ScreenLevelSelectionState[keyof ScreenLevelSelectionState]
        >;
      }>,
    ) => {
      const { screenType, value } = action.payload;
      state[screenType] = value;

      if (
        !screenType?.startsWith("segment") &&
        value?.segments
      ) {
        Object.keys(state).forEach((key) => {
          if (key !== "segment" && state[key]) {
            state[key].segments = value.segments;
          }
        });
      }

      if (
        !screenType.startsWith("market") &&
        value?.markets &&
        value.markets.length > 0
      ) {
        Object.keys(state).forEach((key) => {
          if (key !== "market" && state[key]) {
            state[key].markets = value.markets;
          }
        });
      }
    },
    resetScreenLevelSelection: () => {
      return initialState;
    },
  },
});

export const { updateScreenLevelSelection, resetScreenLevelSelection } =
  screenLevelSelectionSlice.actions;

export default screenLevelSelectionSlice.reducer;
